import moment, { DurationInputArg2 } from 'moment';
import { TimeIn12HourClock } from 'ui/datePicker';
import { ScheduleType } from 'modules/domains/campaign';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { EndEligibilityType, ScheduleEligibilityFormState } from '../../types';
import {
  getScheduleCampaignTargetTimeZone,
  getStartTimeInEpochMs,
} from '../ScheduleCampaignModal/ScheduleCampaignModal.utils';

const getEndDate = ({
  endType,
  endDate,
  startDate,
  endAfterValue,
  endAfterUnit,
}: ScheduleEligibilityFormState) => {
  if (endType === EndEligibilityType.Never) {
    return null;
  } else if (endType === EndEligibilityType.After && endAfterValue && endAfterUnit) {
    return (startDate ?? moment()).add(
      endAfterValue,
      endAfterUnit.toLowerCase() as DurationInputArg2,
    );
  }
  return endDate;
};

export const getEligibilitySchedulePayload = (
  formState: ScheduleEligibilityFormState,
  campaign: GraphQLCampaign,
  sendSize: number,
) => {
  const {
    startTime,
    startDate,
    endTime,
    endAfterValue,
    endAfterUnit,
    endType,
    scheduleType,
    projectTimeZone,
    startingTimeZone,
    fallbackTimeZone,
  } = formState;

  const { schedulerMsgParams, id: campaignId, customQuietHours, customRateLimit } = campaign;

  const isRelativeEnd = endType === EndEligibilityType.After && endAfterValue && endAfterUnit;

  const targetTimeZone = getScheduleCampaignTargetTimeZone(
    projectTimeZone,
    startingTimeZone,
    scheduleType,
  );

  const startTimeAndDateInMs =
    startDate &&
    startTime &&
    getStartTimeInEpochMs(startDate, startTime as TimeIn12HourClock, targetTimeZone);

  const effectiveEndDate = getEndDate(formState);

  const effectiveEndTime = isRelativeEnd ? startTime : endTime;

  const endTimeAndDateInMs =
    effectiveEndDate &&
    getStartTimeInEpochMs(effectiveEndDate, effectiveEndTime as TimeIn12HourClock, targetTimeZone);

  return {
    automaticSendTime: !!schedulerMsgParams?.automaticSendTime,
    campaignId,
    customQuietHours: customQuietHours ?? null,
    customRateLimit: customRateLimit ?? null,
    defaultTimeZone: scheduleType === ScheduleType.ProjectTimeZone ? null : fallbackTimeZone,
    endDate: endTimeAndDateInMs,
    scheduleType,
    sendSize,
    startTime: startTimeAndDateInMs,
    startTimeZone: scheduleType === ScheduleType.RecipientTimeZone ? startingTimeZone : null,
    windowHours: schedulerMsgParams?.windowHours ?? null,
  };
};
